import * as React from 'react';
import { H4Typography } from '@components/atoms';
import { cn } from '@utils';

const PageHeader = React.forwardRef<HTMLHeadElement, React.HTMLAttributes<HTMLHeadElement>>(
	({ className, ...props }, ref) => (
		<header ref={ref} className={cn('w-full grow-0', className)} data-aid="page-header-layout" {...props} />
	)
);
PageHeader.displayName = 'PageHeader';

const PageHeaderContent = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
	({ className, ...props }, ref) => (
		<div
			ref={ref}
			className={cn('flex flex-col justify-between gap-4 bg-white p-5 pt-2 pb-0 ', className)}
			data-aid="page-header-content"
			{...props}
		/>
	)
);
PageHeaderContent.displayName = 'PageHeaderContent';

const PageHeaderMain = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
	({ className, ...props }, ref) => (
		<div
			ref={ref}
			className={cn('flex max-w-full flex-wrap items-center justify-between gap-1.5', className)}
			data-aid="page-header-main"
			{...props}
		/>
	)
);
PageHeaderMain.displayName = 'PageHeaderMain';

const PageHeaderTitle = React.forwardRef<HTMLParagraphElement, React.HTMLAttributes<HTMLParagraphElement>>(
	({ className, ...props }, ref) => (
		<span ref={ref} data-aid="page-header-title">
			<H4Typography className={cn('capitalize', className)} data-aid="page-header-title" {...props} />
		</span>
	)
);
PageHeaderTitle.displayName = 'PageHeaderTitle';

export { PageHeader, PageHeaderTitle, PageHeaderContent, PageHeaderMain };
